import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { DmsIntegrationState } from '@aiwyn/shared';
import { CxpCrlDetailState } from './state/cxp-crl-detail.state';
import { CxpCrlSubscriptionsState } from './state/cxp-crl-subscriptions.state';
import { CxpDeliverableDetailState } from './state/cxp-deliverable-detail.state';

/**
 * The CXP feature state, without the routes. The secure-link flow renders CXP
 * components with no routes of its own, so importing `CxpModule` there would
 * register `CxpRoutingModule` a second time.
 */
@NgModule({
  imports: [
    // DmsIntegrationState is feature-scoped here so the CRL bulk dropzone + upload toast work across the
    // CXP feature. UploadFilesModule also forFeatures it wherever imported; NGXS dedupes the same state.
    NgxsModule.forFeature([CxpDeliverableDetailState, CxpCrlDetailState, CxpCrlSubscriptionsState, DmsIntegrationState]),
  ],
})
export class CxpStateModule {}
